import { Outlet } from "react-router-dom";
import { AuthGuard } from "@/libs/guard/auth-guard";
import { ROLES } from "@/libs/constants/roles";
import ThemeProvider from "@/libs/providers/theme-provider";
import ScrollToTop from "@quest/ui/components/scroll-to-top";
import { useGetParentStudents } from "@quest/shared/member/hooks";
import Loader from "@quest/ui/components/loader";
import { useAppDispatch, useAppSelector } from "@quest/hooks";
import {
  setStudentIdpIds,
  setStudentIds,
  setStudentSchoolYear,
  setStudentFullName,
} from "@quest/slice/parents/parents.slice";
import { IStudent } from "@quest/shared/member/services";
import ParentsNavigationBar from "@/components/parentsNavigationBar";

function ParentsLayout() {
  const { studentId } = useAppSelector((state) => state.auth);
  const { data: parentStudents, isLoading } = useGetParentStudents(
    Number(studentId),
    !!studentId
  );

  const dispatch = useAppDispatch();

  if (parentStudents) {
    dispatch(
      setStudentIds(
        parentStudents?.flatMap((student: { students: IStudent[] }) =>
          student.students.map((student: IStudent) => student.id)
        )
      )
    );
    dispatch(
      setStudentIdpIds(
        parentStudents?.flatMap((student: { students: IStudent[] }) =>
          student.students.map((student: IStudent) => student.idpId)
        )
      )
    );
    dispatch(
      setStudentSchoolYear(
        parentStudents?.flatMap((student: { students: IStudent[] }) =>
          student.students.map((student: IStudent) => student.schoolYear)
        )
      )
    );
    dispatch(
      setStudentFullName(
        parentStudents?.flatMap((student: { students: IStudent[] }) =>
          student.students.map((student: IStudent) => student.fullName)
        )
      )
    );
  }

  if (isLoading) {
    return <Loader />;
  }
  return (
    <AuthGuard requiredRoles={[ROLES.PARENT]} redirectTo="/admin">
      <ThemeProvider>
        <div className="w-[95%] m-auto  pb-[2.5rem]">
          <ParentsNavigationBar />
          <ScrollToTop />

          <Outlet />
        </div>
      </ThemeProvider>
    </AuthGuard>
  );
}

export default ParentsLayout;
